module.exports = __webpack_public_path__ + "43de1aac2010ef084de6194b1fa9f48b.png";